export class EspecialidadeFilialPk {

    idEspecialidade: number = 0;

    idFilial: number = 0;

    constructor() {
    }
}
